// The build version the rail's chip shows beside the lockup (merchant design M:98
// `railVersion`, "V.1.0.2"). It comes from build configuration, never a literal
// (INF-1): the deploy pipeline sets VITE_APP_VERSION; vite.config.ts inlines the
// root package version + commit otherwise (scripts/app-version). Null when the build
// did not stamp a real version — no chip.

/** A stamped version, or null for none / the unreleased 0.0.0 placeholder (no chip). */
export function versionOf(raw: string | undefined): string | null {
  const v = (raw ?? '').trim().replace(/^v(?=\d)/i, '');
  return /^\d+\.\d+(?:\.\d+)?(?:[-+][0-9A-Za-z.+-]+)?$/.test(v) &&
    !/^0\.0(?:\.0)?(?:[-+]|$)/.test(v)
    ? v
    : null;
}

/** The build version (vite.config.ts inlines the CI stamp or the root package version). */
export const appVersion: string | null = versionOf(import.meta.env.VITE_APP_VERSION);

/** The short commit the build came from, shown in the chip's tooltip; null when unknown. */
export const appCommit: string | null = import.meta.env.VITE_APP_COMMIT || null;

/** The chip's tooltip value: "0.1.0 (50365df)", or just the version. */
export const appVersionDetail: string | null =
  appVersion && (appCommit ? `${appVersion} (${appCommit})` : appVersion);
